import type { TFormCheckbox } from '@hubertai/screening-question-types';
import HubiversePropertySelect from 'components/Selects/HubiversePropertySelect';
import type { ComponentProps } from 'react';
import { updateFormHubiverseProperty } from 'rtk/Question.Editor.Slice';
import { useAppSelector, useAppDispatch } from 'rtk/query/hooks';
import { selectQuestionMode } from 'rtk/questionEditorSelector';
import { ECreateQuestionMode } from '../../../context/create-question.context';
interface Props extends ComponentProps<'div'> {
  questionId: string;
  form: TFormCheckbox;
  formIndex: number;
}

const CreateFormCheckbox = ({ questionId, form, formIndex, ...props }: Props) => {
  const dispatch = useAppDispatch();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  return (
    <div {...props}>
      <HubiversePropertySelect
        selected={form.candidate_property ?? ''}
        onSelect={(e: string) => {
          dispatch(updateFormHubiverseProperty({ questionId, formIndex, value: e }));
        }}
        includeLabel={true}
        disabled={mode === ECreateQuestionMode.InTemplateEdit}
      />
    </div>
  );
};

export default CreateFormCheckbox;
